export const UNKNOWN = '(Unknown)';

export const GENERAL_ERROR_MESSAGE =
  'Something went wrong. Please try again later';

export enum IdentityTypeEnum {
  SAIdNumber = 0,
  ForeignIdNumber = 1,
  SAPassport = 2,
}

export enum CompanyTypeEnum {
  Private = 0,
  SoleTrader = 1,
  ClosedCorporation = 2,
  Public = 3,
}

export enum SisAbsentZAIDReason {
  LostId = 1,
  StolenId = 2,
  DamagedId = 3,
}

// TODO: clarify
export enum AddressTypeEnum {
  User = 0,
  Company = 1,
}

export enum ProductTypeEnum {
  Unknown,
  Funding,
  Banking,
}

export enum JumioVerificationStatusEnum {
  Default,
  Added,
  Approved,
  NotApproved,
}

// Documents
export enum DocumentStatusEnum {
  'Submitted',
  'Rejected',
  'Approved',
  'NotSubmitted',
}

export enum DocumentTypeLabelEnum {
  'Business proof of address',
  'Business registration',
  'Personal proof of address',
  'Bank Opening Letter',
  'ID Document',
  'Bank Statement',
  'Source of funds',
  'Source of wealth',
  'Business organogram',
  'Temporary ID',
}

export enum DocumentTypeEnum {
  BusinessAddressRegistration,
  BusinessRegistration,
  PersonalAddressRegistration,
  BankOpeningLetter,
  ID,
  BankStatement,
  SourceOfFunds,
  SourceOfWealth,
  BusinessOrganogram,
  TemporaryID,
}

// Company type
export enum CompanyTypeLabelEnum {
  'Private',
  'Sole Trader',
  'Close Corporation',
  'Public',
}

export const applicationStatusActiveList = [
  'ApprovedAndOffered',
  'ActiveLoan',
  'AdvanceCreated',
];

// Contact/Employees

// Enum internal use only
export enum UserRoleEnum {
  AuthPerson,
  Director,
  Agent,
}

export enum EmployeePositionEnum {
  DirectorMajor,
  Director,
  Shareholder,
  AuthPerson,
  None,
}

export enum EmployeePositionLabelEnum {
  'Director Major Shareholder' = 0,
  'Director' = 1,
  'Major Shareholder' = 2,
  'Auth Person' = 3,
  'None' = 4,
}

export const getFundingReason = (fundingApplication?: any): string => {
  switch (fundingApplication?.fundingReason.toString()) {
    case 'InventoryPurchase':
      return 'Inventory Purchase';
    case 'BridgingLoan':
      return 'Bridging Loan';
    case 'Marketing':
      return 'Marketing';
    case 'EquipmentPurchase':
      return 'Equipment Purchase';
    case 'PayBill':
      return 'Pay Bill';
    case 'PaySalary':
      return 'Pay Salary';
    case 'Refinance':
      return 'Refinance';
    case 'Other':
      return 'Other';
    default:
      break;
  }

  return UNKNOWN;
};

export const getApplicationStatusText = (fundingApplication?: any): string => {
  if (fundingApplication?.status) {
    switch (fundingApplication?.status) {
      case 'ApplicationSubmitted':
      case 'ApplicationInAssessment':
        return 'Review Pending';

      case 'AwaitingFurtherInfoFromCustomer':
        return 'Credit Offer';

      case 'AwaitingFinalDecision':
        return 'Pending Signature';

      case 'Declined':
        return 'Declined';

      case 'AdvanceCreated':
        // TODO: this is temporarily in here because a closed advance
        // shows AdvanceCreated still from the API in the status but the
        // message contains closed
        if (
          fundingApplication?.message &&
          fundingApplication?.message
            ?.toString()
            .toLowerCase()
            .indexOf('closed') !== -1
        ) {
          return 'Closed';
        }

        return 'Active';

      // Not applicable
      // case "ApprovedAndOffered":
      // case "ActiveLoan":
      // case "MaturedAndOverdue":
      // case "SettledAndClosed":
      // case "BcaOffersAvailable":
      // case "DoesNotQualifyForBcaOffers":
      // return fundingApplicationStatus?.toString();

      default:
        return fundingApplication?.status;
    }
  } else {
    return UNKNOWN;
  }
};

export const getBankAccountStatus = (statusCode?: string | null): string => {
  switch (statusCode) {
    case '00':
      return 'Active';
    case '01':
      return 'Inactive';
    case '02':
      return 'New';
    case '10':
      return 'Closed';
    case '11':
      return 'Frozen';
    case '12':
      return 'Not Available';
    case '20':
      return 'Awaiting Deposit';
    case '21':
      return 'Under investigation';
    case '24':
      return 'Dormant';
    case '99':
      return 'Deleted';
    default:
      break;
  }

  return UNKNOWN;
};

export const getAddressText = (address: any | null): string => {
  const array = [
    address?.house,
    address?.street,
    address?.city,
    address?.postCode,
    address?.country,
  ];
  const filtered = array.filter((field: any) => !!field?.trim());

  return filtered.join(', ');
};

const checkAddressCompete = (_address: any | null): boolean => {
  const address = { ..._address };

  return (
    address?.countryIso2Code?.trim() &&
    address?.subdivision?.trim() &&
    address?.street?.trim() &&
    address?.area?.trim() &&
    address?.city?.trim() &&
    address?.postCode?.trim()
  );
};

export const checkCompanyDetailsComplete = (_company: any): boolean => {
  const company = { ..._company };

  return (
    company?.companyType in CompanyTypeEnum &&
    company?.yearsOperational &&
    company?.annualTurnover &&
    company?.name?.trim() &&
    company?.tradingAs?.trim() &&
    company?.vatRegistrationNumber?.trim() &&
    company?.primaryContactNumber?.trim() &&
    checkAddressCompete(company?.address) &&
    (company?.companyType === CompanyTypeEnum.SoleTrader
      ? company?.vatRegistrationNumber?.trim()
      : company?.registrationNumber?.trim())
  );
};

export const checkContactDetailsComplete = (_contact: any): boolean => {
  const contact = { ..._contact };

  return (
    !!contact &&
    contact?.firstName?.trim() &&
    contact?.lastName?.trim() &&
    contact?.phoneNumber?.trim() &&
    checkAddressCompete(contact?.address)
  );
};
